import HappyLine from 'js/components/HappyLine/HappyLine'
import React from 'react'
import PropTypes from 'prop-types'
import PremiumButton from '../PremiumButton/PremiumButton'
import Header from '../Header/Header'
import { getMiscData } from '../../wpapi'
import { throttle } from 'throttle-debounce'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { withLocale, localeShape } from '../../locale'
import { trackReadMoreInHero } from '../../analytics'
import Video from './Video'

class Hero extends React.Component {
  wrapper = React.createRef()
  bg = React.createRef()
  video = React.createRef()

  static propTypes = {
    locale: localeShape,
    premium: PropTypes.bool.isRequired,
    onClickFunc: PropTypes.func,
    onClickFuncMobile: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      reviewCount: false,
      showMobileCTA: false,
      showMobileCTAWithDelay: false,
    }

    this.scrollToContent = this.scrollToContent.bind(this)
  }

  componentDidMount() {
    getMiscData().then(data => {
      this.setState({
        reviewCount: data.acf.number_of_reviews,
      })
    })

    window.addEventListener(
      'scroll',
      throttle(100, this.checkSignUpBoxPositionInMobile)
    )

    this.checkSignUpBoxPositionInMobile()
  }

  checkSignUpBoxPositionInMobile = () => {
    if (this.bg.current) {
      const showMobileCTA =
        this.bg.current.getBoundingClientRect().top <
        this.bg.current.getBoundingClientRect().height * -1

      if (!this.state.showMobileCTA && showMobileCTA && !this.state.scrolling) {
        this.setState({
          showMobileCTA: true,
          showMobileCTAWithDelay: true,
        })
      } else if (this.state.showMobileCTA && !showMobileCTA) {
        this.setState({
          showMobileCTA: false,
        })
        setTimeout(() => {
          this.setState({
            showMobileCTAWithDelay: false,
          })
        }, 400)
      }
    }
  }

  scrollToContent() {
    trackReadMoreInHero()
    const destination =
      this.video.current.offsetParent !== null
        ? this.bg.current.getBoundingClientRect().height - 100
        : this.wrapper.current.getBoundingClientRect().height

    const scrollingElement =
      document.scrollingElement || document.documentElement

    function scrollTo(element, to, duration) {
      if (duration <= 0) return
      const difference = to - element.scrollTop
      const perTick = (difference / duration) * 10

      setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick
        if (element.scrollTop == to) return
        scrollTo(element, to, duration - 10)
      }, 10)
    }

    scrollTo(scrollingElement, destination, 300)
  }

  render() {
    return (
      <div className="c-hero" ref={this.wrapper}>
        <div className="c-hero__background" ref={this.bg}>
          <Header sticky={false} />
          <div className="o-width-limiter">
            <div className="c-hero__inner">
              <div className="c-hero__text-wrapper">
                <h1 className="c-hero__slogan font-bold" data-uid="intro-title">
                  <FormattedMessage id="Jumbotron.intro.title" />
                  {this.props.locale.language !== 'fr' &&
                    this.props.locale.language !== 'ru' && <br />}
                  {(this.props.locale.language === 'fr' ||
                    this.props.locale.language === 'ru') && <span> </span>}
                  <FormattedMessage {...messages.subTitle} />
                </h1>
                <p className="text-27 lg:text-34 xl:text-40 leading-tight mt-16 mb-30 lg:mt-24 lg:mb-40">
                  <FormattedMessage {...messages.homepage_tagline} />
                </p>
                <div className="c-hero__buttons">
                  <button
                    onClick={this.scrollToContent}
                    className="c-button c-button--block c-button--white-border mb-12 c-premium-button__cta mt-0 flex-shrink-0"
                  >
                    <span>
                      <FormattedMessage {...messages.readMore} />
                    </span>
                  </button>
                  {!this.props.premium && (
                    <div>
                      <div className="hidden lg:block">
                        <PremiumButton
                          signUpCopyBlock={true}
                          marginless={true}
                          signupCopyShadowBlack={true}
                          onClickFunc={this.props.onClickFunc}
                          newStartpage={true}
                          countdown={false}
                          priceInside={true}
                          GALabel="Desktop hero CTA"
                        />
                      </div>
                      <div className="lg:hidden">
                        <PremiumButton
                          signUpCopyBlock={true}
                          marginless={true}
                          signupCopyShadowBlack={true}
                          onClickFunc={this.props.onClickFunc}
                          newStartpage={true}
                          GALabel="Mobile hero CTA"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="c-hero__reviews">
                <p className="c-hero__reviews-heading">
                  {this.state.reviewCount && (
                    <strong className="font-bold">
                      {this.state.reviewCount.substring(0, 3) +
                        ' ' +
                        this.state.reviewCount.substring(3)}
                    </strong>
                  )}{' '}
                  <FormattedMessage {...messages.homepage_reviews_copy} />
                </p>
                <ul className="c-hero__reviews-list">
                  <li className="c-hero__reviews-list-item">
                    <span className="c-hero__reviews-logo c-hero__reviews-logo--apple">
                      Apple AppStore:{' '}
                    </span>
                    <div className="c-hero__stars  c-review">
                      <div
                        className={'c-review__rating  c-review__rating--4-75'}
                      />
                    </div>
                    <span className="c-hero__reviews-score">4.7</span>
                    <span className="visually-hidden">average rating</span>
                  </li>
                  <li className="c-hero__reviews-list-item">
                    <span className="c-hero__reviews-logo c-hero__reviews-logo--android">
                      Google Play:{' '}
                    </span>
                    <div className="c-hero__stars  c-review">
                      <div
                        className={'c-review__rating  c-review__rating--4-5'}
                      />
                    </div>
                    <span className="c-hero__reviews-score">4.4</span>
                    <span className="visually-hidden">average rating</span>
                  </li>
                </ul>
              </div>
              <div className="hidden lg:block">
                <Video />
              </div>
            </div>
          </div>
          <HappyLine className="c-hero__curve" color="Bg" />
        </div>
        <div className="lg:hidden" ref={this.video}>
          <Video />
        </div>
        {!this.props.premium && (
          <div
            className={`c-hero__mobile-cta  lg:hidden${
              this.state.showMobileCTA ? ' c-hero__mobile-cta--shown' : ''
            }`}
          >
            {this.state.showMobileCTAWithDelay && (
              <PremiumButton
                signUpCopyBlock={true}
                marginless={true}
                signupCopyShadowBlack={false}
                onClickFunc={this.props.onClickFunc}
                newStartpage={true}
                priceInside={true}
                GALabel="Mobile sticky CTA"
              />
            )}
          </div>
        )}
      </div>
    )
  }
}

export default withLocale(Hero)
